<template>
  <SimpleDataCard
      :title="'Toplam Alacak Tutarı'"
      :data="numberConverter(reportCompanyData.totalCurrentDebit)"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamAlacakTutari",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>